<template>
  <div>
    <b-row
      v-if="isRequired && direccion"
    >
      <b-col cols="12">
        <b-row>
          <b-col
            xl="12"
            lg="12"
            md="12"
            sm="12"
          >
            <b-alert
              show
              variant="primary"
            >
              <div class="alert-body">
                <feather-icon
                  class="mr-25"
                  icon="MapPinIcon"
                />
                <span class="ml-25">Dirección para Notificaciones</span>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </b-col>

      <b-col>
        <div class="mx-1 mb-1">
          <h5 class="text-capitalize mb-75">
            Entidad federativa:
          </h5>
          <b-card-text>
            {{ direccion.entidad_federativa }}
          </b-card-text>
          <h5 class="text-capitalize mb-75">
            Alcaldía:
          </h5>
          <b-card-text>
            {{ direccion.alcaldia }}
          </b-card-text>
          <h5 class="text-capitalize mb-75">
            Colonia:
          </h5>
          <b-card-text>
            {{ direccion.colonia }}
          </b-card-text>
          <h5 class="text-capitalize mb-75">
            Código Postal:
          </h5>
          <b-card-text>
            {{ direccion.codigo_postal }}
          </b-card-text>

        </div>
      </b-col>
      <b-col>

        <h5 class="text-capitalize mb-75">
          Calle:
        </h5>
        <b-card-text>
          {{ direccion.calle }}
        </b-card-text>
        <h5 class="text-capitalize mb-75">
          Número Exterior:
        </h5>
        <b-card-text>
          {{ direccion.numero_exterior }}
        </b-card-text>
        <h5 class="text-capitalize mb-75">
          Número Interior:
        </h5>
        <b-card-text>
          {{ direccion.numero_interior || 'No aplica' }}
        </b-card-text>

      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <b-alert
          show
          variant="primary"
        >
          <div class="alert-body">
            <feather-icon
              class="mr-25"
              icon="MapPinIcon"
            />
            <span class="ml-25">Dirección para Notificaciones</span>
          </div>
        </b-alert>
      </b-col>
      <b-col>
        <h5>Esta convocatoria no requiere estos datos.</h5>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAlert, BCol, BCardText, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'DireccionNotificaciones',
  directives: {
    Ripple,
  },
  components: {
    BAlert,
    BCol,
    BCardText,
    BRow,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    data: {
      type: [Object, Array],
      default: () => {},
    },
    isRequired: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isEdit: false,
      direccion: null,
    }
  },
  mounted() {
    this.direccion = { ...this.data }
  },
  methods: {
    updateDireccion(obj) {
      this.direccion = { ...obj }
    },
  },
}
</script>

<style></style>
